import { assetRepository } from "./assetRepository";

export const assetService = {
  list: (siteId: string) => assetRepository.list(siteId),
  updateAltText: (assetId: string, altText: string) =>
    assetRepository.update(assetId, { alt_text: altText.trim() }),
  // `folder` comes from 20261007154250_media_folders; until the generated
  // types know it, the update is typed loosely.
  updateFolder: (assetId: string, folder: string | null) =>
    assetRepository.update(assetId, { folder: folder?.trim() || null } as never),

  async upload(siteId: string, file: File, altText = "") {
    const asset = await assetRepository.upload(siteId, file, altText.trim());
    return { asset, publicUrl: assetRepository.getPublicUrl(asset.storage_path) };
  },

  async remove(assetId: string) {
    await assetRepository.remove(assetId);
  },

  getPublicUrl: (path: string) => assetRepository.getPublicUrl(path),
};
